module.exports = __webpack_public_path__ + "media/music_8.ca3531c2.mp3";